export default "__VITE_ASSET__CJI9P9xZ__"